// LinkedIn Lab mock data

export const FOUNDER_AVATARS = [
  'https://framerusercontent.com/images/LdiJIgo7vhBde0WiWHd48uSzxU.png?width=512&height=512',
  'https://framerusercontent.com/images/I9yoNS4RgoWEeRpJDtgEIoLAd4Y.png?width=512&height=512',
  'https://framerusercontent.com/images/G5E86VA7DStEga3pPtCu3nwW1qE.png?width=512&height=512',
];

export const CONTACT_EMAIL = 'mbshelar98@gmail.com';

export const STATS = [
  { value: '10.19M', label: 'Impressions generated' },
  { value: '242%', label: 'Follower growth for one client in 349 days' },
  { value: '96%', label: 'Posting consistency. No paid promotion.' },
];

export const TESTIMONIALS = [
  {
    id: '01',
    image: 'https://framerusercontent.com/images/nURHcgFo9S6zVF3j0ly85sSmvE.png?width=1488&height=920',
    quote: 'We had solid content going out but nothing was converting. LinkedIn Lab rebuilt the whole back end. Lead magnets, DM sequences, all of it. First inbound lead came in week six.',
    name: 'Founder',
    role: 'B2B SaaS, Manufacturing Sector',
  },
  {
    id: '02',
    image: 'https://framerusercontent.com/images/j4kitBgDVx6ElGDAGtpxlM7RoHg.png?width=1488&height=920',
    quote: 'What stood out was the onboarding. Two weeks of calls before a single post went live. By the time content started, it actually sounded like me. Previous ghostwriters never got close.',
    name: 'Co-Founder',
    role: 'Industrial Services, Series A',
  },
];

export const RESULTS = [
  {
    id: '01',
    title: 'Audience Growth',
    body: 'Follower count grew from 8,358 to 28,592, a 242% increase, over 349 days. 58 new followers per day on average. 35.5% of the audience at Director level or above.',
    tags: ['Personal Profile', 'Manufacturing SaaS', 'Organic Only'],
  },
  {
    id: '02',
    title: 'Reach & Engagement',
    body: '10.19M total impressions. 2.73M unique professionals reached. 1.42% engagement rate against a B2B benchmark of 0.5 to 1.0%. Daily impressions grew 4x, from 7,326 to 29,201.',
    tags: ['96% posting consistency', '335 of 349 days published'],
  },
  {
    id: '03',
    title: 'Audience Quality',
    body: 'Companies represented in the audience include Unilever, Whirlpool, Ford, Amazon, and Stellantis. Senior-level professionals made up over a third of all engagement.',
    tags: ['Enterprise Reach', 'Zero Ad Spend', 'B2B Decision-Makers'],
  },
];

export const SERVICES = [
  {
    key: 'voice',
    title: 'Voice Extraction',
    description:
      'We spend two weeks inside your world before writing a single word. Deep-dive calls, sales recordings, customer language. The goal is the version of you that makes buyers think "this person gets my problem", not a surface-level brand questionnaire.',
    tags: ['Voice Profile', 'Positioning Statement', 'Content Pillars', 'Profile Optimization'],
  },
  {
    key: 'content',
    title: 'Content Engine',
    description:
      '3 to 5 posts per week in your voice. One 45-minute call per month gives us everything we need. No motivational quotes, no engagement bait. Posts that make your ideal buyers stop scrolling and think "I need to talk to this person."',
    tags: ['Written & Scheduled', 'Comment Engagement', 'Monthly Strategy Call'],
  },
  {
    key: 'conversion',
    title: 'Conversion Layer',
    description:
      'This is where every ghostwriter stops. Lead magnet CTAs in posts. Profile views converted to warm DM outreach. Comment engagement turned into relationships. The full stack, built and running. Content creates attention. The conversion layer captures it.',
    tags: ['Lead Magnets', 'DM Scripts', 'Email Nurture', 'Landing Pages'],
  },
  {
    key: 'reporting',
    title: 'Reporting',
    description:
      "We don't report impressions. We report pipeline. Every month: what worked, what resonated with buyers (not just what got likes), and where to double down next.",
    tags: ['Pipeline Metrics', 'Calls Booked', 'Conversion Data', 'Audience Composition'],
  },
];

export const FOUNDER = {
  name: 'LinkedIn Lab',
  title: 'About',
  bio: 'LinkedIn Lab is a GTM partner for B2B founders who want LinkedIn to generate revenue, not just attention. We run a small roster of three to five founders at a time, so every engagement gets the same depth of attention as the first one.',
  bio2: "We don't start writing on day one. We spend two weeks inside your world before a single post goes live. After that, we build the entire system: content, conversion infrastructure, and pipeline reporting. And we stay accountable to the numbers that actually matter.",
  experience: [
    { role: 'LinkedIn Lab', period: '2022 to Now' },
    { role: '10M+ impressions delivered', period: 'Organic only' },
    { role: 'B2B founders served', period: 'Manufacturing, SaaS, Industrial' },
    { role: 'Small roster', period: '3 to 5 clients at a time' },
  ],
};

export const PRICING = [
  {
    plan: 'Content Presence',
    description:
      'A consistent, high-quality LinkedIn presence that sounds exactly like you. The foundation.',
    delivery: 'Month-to-month',
    features: [
      '2-week voice extraction and onboarding',
      '3 to 5 posts per week in your voice',
      'Full profile optimization',
      'Monthly strategy call',
      'Engagement management',
    ],
    accent: false,
    badge: '',
  },
  {
    plan: 'Revenue System',
    description:
      'LinkedIn as a revenue channel, with the full conversion infrastructure to prove it.',
    delivery: 'Month-to-month',
    features: [
      'Everything in Content Presence',
      'Lead magnets, landing pages, DM funnels',
      'Email nurture sequences',
      'Active outreach management',
      'Pipeline tracking and monthly reporting',
    ],
    accent: true,
    badge: 'Full System',
  },
];

export const FAQS = [
  {
    q: 'What makes this different from a ghostwriter?',
    a: 'Ghostwriters write posts. We build pipeline. The difference is the conversion layer: lead magnets, DM sequences, email nurture, outreach cadences. Most ghostwriters stop at content. We build everything that turns content into revenue.',
  },
  {
    q: 'How long before we see results?',
    a: "Content authority compounds over time. Most clients see the first real inbound signals by month two or three. The conversion layer is fully running by end of month two. We set this expectation upfront. If you need results in week one, we're not the right fit.",
  },
  {
    q: 'How much of my time does this take?',
    a: "One 45-minute call per month. Quick approvals on posts before they go live. Not a committee review, just a fast yes or edit. Voice notes and async Loom recordings fill the gaps. We designed it so founders who don't have two hours a day for LinkedIn can still have a serious presence on it.",
  },
  {
    q: 'Do I have to sign a contract?',
    a: 'No. Month-to-month, cancel anytime. We keep clients because the results justify it, not because of a lock-in.',
  },
  {
    q: 'Who is this not right for?',
    a: "Pre-revenue founders looking for their first customer (LinkedIn compounds, it doesn't cold-start). Anyone who wants 10K followers in 90 days. Founders who need to approve every comma. The system only works if there's trust.",
  },
  {
    q: 'What industries do you work with?',
    a: "Primarily manufacturing, industrial SaaS, B2B SaaS, consulting firms, and professional services. If you're a B2B founder doing $100K to $1M+ in annual revenue and LinkedIn is an underused channel, that's the conversation.",
  },
];

export const NOISE_BG =
  'https://framerusercontent.com/images/qDuGmDXhhbdrJsP16G4zNCDX8.png?width=1440&height=1840';
